import React from 'react'
import { SurveyItemQuestionType } from '../SurveyTempleteFeature/types'
import FreeResponseCard from '../SurveyFeature/components/FreeResponseCard'
import MultipleChoiceCard from '../SurveyFeature/components/MultipleChoiceCard'
import LinearScaleCard from '../SurveyFeature/components/LinearScaleCard'
import MultiSelectCard from '../SurveyFeature/components/MultiSelectCard'
import { Chip } from '@mui/material'
import { blue } from '../../colors'

export const showQuestion = (section: any): JSX.Element => {
  let questionNumber = 0

  return section.surveyItems.map((question: any) => {
    if (question.itemType !== SurveyItemQuestionType.DESCRIPTIVE_TEXT) {
      questionNumber++
    }

    const commonProps = {
      questionNumber,
      disabled: false,
      title: question.prompt,
      name: `${question.itemId}${section.instructorId || ''}`,
      isRequired: question.isRequired,
      invalidQuestionItemId: ''
    }

    switch (question.itemType) {
      case SurveyItemQuestionType.FREE_RESPONSE:
        return <FreeResponseCard {...commonProps} />
      case SurveyItemQuestionType.MULTIPLE_CHOICE:
        return <MultipleChoiceCard {...commonProps} options={question.object} />
      case SurveyItemQuestionType.LINEAR_SCALE:
        return <LinearScaleCard {...commonProps} options={question.object} />
      case SurveyItemQuestionType.DESCRIPTIVE_TEXT:
        return <p>{question.prompt}</p>
      case SurveyItemQuestionType.MULTI_SELECT:
        return <MultiSelectCard {...commonProps} options={question.object} />
      default:
        return <></>
    }
  })
}

export const renderAttributeChip = (attr: { values: string[], op?: string }, index: number): JSX.Element | null => {
  if (!attr?.values || attr.values.length === 0) return null
  const modifiedValues = attr.op === 'is not'
    ? attr.values.map((value: string) => `Not ${value}`).slice(0, 2).join(', ')
    : attr.values.slice(0, 2).join(', ')
  const remainingValues = attr.values.length > 2 ? `+${attr.values.length - 2}` : ''
  const label = `${modifiedValues} ${remainingValues}`.trim()
  return (
      <Chip
        key={index}
        label={label}
        variant="filled"
        color="info"
        size="small"
        sx={{
          borderRadius: '6px',
          border: `1px solid ${blue[150]}`,
          fontWeight: 500,
          color: blue[450],
          backgroundColor: blue[0],
          marginRight: 1
        }}
      />
  )
}
